module.exports = "../fonts/check_box_empty_gray.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/check_box_empty_gray.svg
// module id = 324
// module chunks = 0